/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { MenuComponent } from '../../../_metronic/assets/ts/components'
import arrow from '../../../_metronic/images/arr072.svg'
import { useLazyQuery } from '@apollo/client'
import { GETCLIENTDETAILS, GET_TPV_ADMIN_CLIENT_TPV_LIST } from '../../../utils/GraphQLAPI'
import { BASE_URL } from '../../../utils/config'
import DateRangePickers from '../../sharedComponent/DateRangePickers/DateRangePickers'
import './TotalTPVList.css'
import moment from 'moment'
import { KTCard, KTCardBody } from '../../../_metronic/helpers'
import { Spinner } from 'react-bootstrap'
import { getToken } from '../../../utils/helper'
import fileDownload from 'js-file-download'
import momentTimezone from 'moment-timezone'
import DownloadCsv from '../Download/DownloadCsv'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Select from 'react-select'
import { GLOBAL_CONSTANTS } from '../../../utils/GlobalConstants'
import { listHeaderName } from './TotalTPVListUtils'
const MySwal = withReactContent(Swal)

type Props = {
  className: string
  children?: React.ReactNode
}
const TotalTPVList: React.FC<Props> = ({ className, children }) => {
  const [client, setClients] = useState<any>([])
  const [tpvAdminClientTpvList, setTpvAdminClientTpvList] = useState<any>()
  const [filterClient, setFilterClient] = useState<any>({ label: 'All Clients', value: '' })
  const [customerStatus, setCustomerStatus] = useState<any>(null)
  const [filterOptions, setFilterOptions] = useState<any>({
    clientIds: [],
    fromDate: new Date(
      moment(moment().subtract(29, 'days').toDate()).format('YYYY-MM-DD') + 'T00:00:00'
    ).toISOString(),
    toDate: new Date(moment(moment().toDate()).format('YYYY-MM-DD') + 'T23:59:00').toISOString(),
  })
  const [downloadData, setDownloadData] = useState<any>([])
  const csvRef = useRef<any>(null)
  console.log('filterOptions', filterOptions);
  // Get Client query for client dropdown
  const [getClientDetails] = useLazyQuery(GETCLIENTDETAILS, {
    onCompleted: (data) => {
      setClients(
        data?.getAllClients?.map((client: any) => ({ label: client.name, value: client.id }))
      )
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  // GetTpvAdminClientTpvList query for list values
  const [GetTpvAdminClientTpvList, { loading }] = useLazyQuery(GET_TPV_ADMIN_CLIENT_TPV_LIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data) => {
      setTpvAdminClientTpvList(data?.getTpvAdminClientTpvList)
    },
  })

  // For CSV Download
  const [GetTpvAdminClientTpvCSVList, { loading: reload }] = useLazyQuery(
    GET_TPV_ADMIN_CLIENT_TPV_LIST,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      onCompleted: (data) => {
        setDownloadData(
          data?.getTpvAdminClientTpvList.map((tpv: any) => {
            return { ...tpv, totalSeconds: `${tpv.totalSeconds / 60}` }
          })
        )
      },
    }
  )

  const getdataFromDateFilter = (fromDate: any, toDate: any, objDays: any) => {
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, fromDate, toDate }
    })
  }

  useEffect(() => {
    getClientDetails()
    MenuComponent.reinitialization()
  }, [])

  useEffect(() => {
    GetTpvAdminClientTpvList({
      variables: {
        filter: filterOptions,
      },
    })
  }, [filterOptions])

  useEffect(() => {
    if (filterClient.value === '') {
      setFilterOptions((prev: any) => ({ ...prev, clientIds: [] }))
    } else {
      setFilterOptions((prev: any) => ({ ...prev, clientIds: [filterClient.value] }))
    }
  }, [filterClient])
  const getCustomersbyTpvStatus = (statusFilter: any) => {
    statusFilter === null && setCustomerStatus('Both')
    statusFilter === true && setCustomerStatus('Active')
    statusFilter === false && setCustomerStatus('Inactive')
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, isActive: statusFilter }
    })
  }

  // Download
  const handleDownloadReports = async (clientId: string, clientName: string) => {
    const downloadURL = `${process.env.REACT_APP_BASE_URL}downloads/tpvReports/Excel/${clientId}`

    const TOKEN = await getToken()
    const res = await fetch(downloadURL, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        reportTimeZone: momentTimezone.tz.guess(),
        fromDate: filterOptions.fromDate,
        toDate: filterOptions.toDate,
      }),
    })
    const blob = await res.blob()
    const newBlob = new Blob([blob])
    fileDownload(newBlob, `${clientName}.xlsx`)
  }

  // CSV Download
  const csvHeaders = [
    { label: listHeaderName.clientName, key: 'name' },
    { label: listHeaderName.agents, key: 'noOfAgents' },
    { label: listHeaderName.totalTpvs, key: 'totalTpvs' },
    { label: listHeaderName.totalIvrMins, key: 'totalIVRSeconds' },
    { label: listHeaderName.totalLiveAgentMins, key: 'totalLiveAgentSeconds' },
    { label: listHeaderName.textTPvs, key: 'textTpvs' },
    { label: listHeaderName.enrollments, key: 'totalEnrollments' },
    { label: listHeaderName.contractSent, key: 'contractSends' },
    { label: listHeaderName.imageUploaded, key: 'imageUploadsCount' },
    { label: listHeaderName.totalTexts, key: ' totalTexts' },
  ]

  const csvDownloadFun = async () => {
    await GetTpvAdminClientTpvCSVList({
      variables: {
        filter: filterOptions,
      },
    })
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  return (
    <>
      <KTCard>
        <div className='card-header card-header card-body pb-0 border-0'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Total TPVs</span>
          </h3>
          <div className='d-flex'>
            <div className='m-0'>
              {tpvAdminClientTpvList?.length !== 0 && (
                <DownloadCsv
                  csvDownloadFun={csvDownloadFun}
                  reload={reload}
                  csvHeaders={csvHeaders}
                  csvRef={csvRef}
                  downloadData={downloadData}
                  downloadFileName='Total_TPVs.csv'
                />
              )}
            </div>

            <Select
              id={'allclient'}
              className={`basic-single min-w-200px mw-200px ${className}`}
              classNamePrefix='dropdown'
              menuShouldScrollIntoView={false}
              placeholder={
                <div
                  style={{
                    fontSize: '1.1rem',
                    fontWeight: '500',
                    color: 'var(--kt-input-solid-color)',
                  }}
                >
                  Select option
                </div>
              }
              // isClearable
              isSearchable
              name={'clientFilter'}
              defaultValue={filterClient}
              value={filterClient}
              options={[{ label: 'All Clients', value: '' }, ...client]}
              onChange={(value) => {
                setFilterClient(value)
              }}
            />

            <div className='h-38px border-0 rounded ms-4'>
              <a
                href='#'
                className='btn btn-lignt btn-sm  bg-secondary d-flex align-items-center justify-content-between w-170px'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                style={{
                  borderRadius: '6px',
                  height: '43px',
                  width: '190px',
                }}
              >
                {customerStatus ? customerStatus : 'Status'}
                <img src={arrow} alt='' width='22px' height='22px' />
              </a>

              {/* begin::Menu */}
              <div
                className='menu menu-sub menu-sub-dropdown menu-column menu-gray-600 menu-state-bg-primary w-auto fs-7 py-4 w-170px'
                data-kt-menu='true'
                style={{
                  borderRadius: '6px',
                  width: '190px',
                  maxHeight: '200px',
                  overflowY: 'scroll',
                }}
              >
                <div className='menu-item' style={{ width: '180px' }}>
                  <a
                    className='menu-link px-3'
                    onClick={() => {
                      getCustomersbyTpvStatus(null)
                    }}
                  >
                    Both
                  </a>
                </div>
                <div className='menu-item' style={{ width: '180px' }}>
                  <a
                    className='menu-link px-3'
                    onClick={() => {
                      getCustomersbyTpvStatus(true)
                    }}
                  >
                    Active
                  </a>
                </div>
                <div className='menu-item' style={{ width: '180px' }}>
                  <a
                    className='menu-link px-3'
                    onClick={() => {
                      getCustomersbyTpvStatus(false)
                    }}
                  >
                    Inactive
                  </a>
                </div>
              </div>
            </div>

            {/* // date filter */}
            <div className='w-116px h-38px border-0 tpv-list-date-filter ms-4'>
              <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} />
            </div>
          </div>
        </div>
        {children && (
          <div className='px-9 pt-4 pb-2'>
            {React.isValidElement(children)
              ? React.cloneElement(children, { filterOptions })
              : children}
          </div>
        )}
        {/* begin::Header */}
        <div className='card card-custom'>


          {/* end::Header */}

          {/* begin::Body */}
          <KTCardBody className='px-9 py-0 min-h-400px' scroll>
            {/* begin::Table container */}
            {/* begin::Table */}
            <div className='table-container'>
              {tpvAdminClientTpvList?.length !== 0 ? (
                <div className='table-responsive-xxl'>
                  {loading ? (
                    <div className='text-center mt-4'>
                      <Spinner
                        animation='border'
                        className='text-gray-600 text-center'
                        role='status'
                      >
                        <span className='visually-hidden'>Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4 mt-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                          <th className='sticky-header header-title min-w-280px'>
                            {listHeaderName.clientName}
                          </th>
                          <th className='header-title min-w-80px'>{listHeaderName.agents}</th>
                          <th className='header-title min-w-100px'>{listHeaderName.totalTpvs}</th>
                          <th className='header-title min-w-80px'>
                            {listHeaderName.totalIvrMins}
                          </th>
                          <th className='header-title min-w-100px text-ellipsis'>
                            {listHeaderName.totalLiveAgentMins}
                          </th>
                          <th className='header-title min-w-90px'>{listHeaderName.textTPvs}</th>
                          <th className='header-title min-w-100px'>{listHeaderName.enrollments}</th>
                          <th className='header-title min-w-100px text-ellipsis' title='Contract Sent'>{listHeaderName.contractSent}</th>
                          <th className='header-title min-w-100px text-ellipsis'>
                            {listHeaderName.imageUploaded}
                          </th>
                          <th className='header-title min-w-100px text-ellipsis'>{listHeaderName.totalTexts}</th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {tpvAdminClientTpvList &&
                          tpvAdminClientTpvList.map((tpv: any) => {
                            return (
                              <tr key={tpv.clientId} className='border-bottom-2'>
                                <td className='sticky-header content min-w-280px'>
                                  <div className='symbol symbol-50px me-2 d-flex'>
                                    <span className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                                      <img
                                        src={
                                          tpv.logoUrl
                                            ? `${BASE_URL + tpv.logoUrl}`
                                            : 'https://cdn-icons-png.flaticon.com/512/5486/5486264.png'
                                        }
                                        style={{ objectFit: 'contain' }}
                                        alt=''
                                      />
                                    </span>
                                    <div
                                      className='d-flex flex-column'
                                      style={{ marginLeft: '10px' }}
                                    >
                                      <span className='text-dark fw-5 d-block mb-1 fs-14px'>
                                        {tpv.name}
                                      </span>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {tpv.city}, {tpv.country} {tpv.zipCode}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className='content min-w-80px'>{tpv.noOfAgents}</td>
                                <td className='content min-w-100px'>{tpv.totalTpvs}</td>
                                <td className='content min-w-80px'>{tpv.totalIVRSeconds}</td>
                                <td className='content min-w-100px'>{tpv.totalLiveAgentSeconds}</td>
                                <td className='content min-w-90px'>{tpv.textTpvs}</td>
                                <td className='content min-w-100px'>{tpv.totalEnrollments}</td>
                                <td className='content min-w-100px'>{tpv.contractSends}</td>
                                <td className='content min-w-100px'>{tpv.imageUploadsCount}</td>
                                <td className='content min-w-100px'>{tpv.totalTexts}</td>
                                <td className='content min-w-100px'>
                                  <a
                                    className={`btn btn-sm btn-icon btn-light btn-active-light-primary fw-bold fs-base`}
                                    onClick={(e) => handleDownloadReports(tpv?.clientId, tpv?.name)}
                                  >
                                    <span className='svg-icon svg-icon-6 svg-icon-muted m-0'>
                                      <svg
                                        width='15'
                                        height='15'
                                        viewBox='0 0 14 15'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          opacity='0.5'
                                          d='M7.00041 0.500108C7.22667 0.500463 7.44368 0.593641 7.6036 0.759192C7.76366 0.924623 7.85375 1.14906 7.8541 1.38307V7.26761L10.5516 4.94237C10.7256 4.79267 10.9499 4.72053 11.1752 4.74182C11.4005 4.76299 11.6086 4.87568 11.7535 5.05528C11.8985 5.23526 11.9683 5.46737 11.9478 5.70068C11.9273 5.93387 11.8181 6.14919 11.6443 6.29915L7.5468 9.83097C7.5037 9.86243 7.45797 9.88986 7.41018 9.91292C7.37919 9.93396 7.34707 9.95312 7.31391 9.97015C7.11475 10.0568 6.8902 10.0568 6.69106 9.97015C6.6579 9.95336 6.626 9.93432 6.59548 9.91292C6.54643 9.88998 6.49956 9.8623 6.45542 9.83026L2.35788 6.29844C2.1777 6.14271 2.06748 5.91686 2.05331 5.67445C2.03914 5.43192 2.12226 5.194 2.283 5.01685C2.44375 4.83971 2.66794 4.73897 2.9029 4.73814C3.10252 4.73885 3.29562 4.81122 3.44928 4.94307L6.14675 7.26761V1.38307C6.1471 1.14905 6.23719 0.924598 6.39725 0.759192C6.55719 0.593641 6.77417 0.500462 7.00041 0.500108Z'
                                          fill='currentColor'
                                        />
                                        <path
                                          d='M13.1462 9.85042C12.9199 9.85077 12.7029 9.94395 12.543 10.1094C12.383 10.2749 12.2929 10.4993 12.2925 10.7333V12.6757H1.70739V10.7333C1.70739 10.4179 1.5447 10.1264 1.28048 9.96865C1.01638 9.81091 0.690992 9.81091 0.426906 9.96865C0.162693 10.1264 0 10.4179 0 10.7333V13.5587C0.000342994 13.7927 0.0904326 14.0171 0.250494 14.1826C0.410439 14.348 0.627439 14.4412 0.853682 14.4415H13.1463C13.3726 14.4412 13.5896 14.348 13.7495 14.1826C13.9096 14.017 13.9997 13.7927 14 13.5587V10.7333C13.9997 10.4992 13.9096 10.2749 13.7495 10.1094C13.5896 9.94395 13.3726 9.85077 13.1463 9.85042H13.1462Z'
                                          fill='currentColor'
                                        />
                                      </svg>
                                    </span>
                                  </a>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                  )}
                </div>
              ) : (
                <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center mt-10'>
                  No Results Found
                </div>
              )}

              {/* end::Table */}
              {/* end::Table container */}
            </div>
          </KTCardBody>
          {/* begin::Body */}
        </div>
      </KTCard>
    </>
  )
}

export { TotalTPVList }
